/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import FormFactory from "../../../components/form/form-factory";

import LucralizeLogo from "../../../assets/svgs/LucralizeLogo.svg";

import * as S from "./styles";

import IProps from "./props";

const Register: React.FC<IProps> = ({ onSubmit, dataForm, errorMessage }) => (
  <S.Container>
    <S.Header>
      <img src={LucralizeLogo} alt="logo" />
    </S.Header>
    <S.SubTitle>Seja bem vindo!</S.SubTitle>
    <S.Title>
      Para prosseguir cadastre <br /> um e-mail e senha
    </S.Title>
    <S.FormWrapper>
      <FormFactory
        data={dataForm}
        onSubmit={onSubmit}
        submitErrorMessage={errorMessage}
      />
    </S.FormWrapper>
    <S.TermsLink to="/termos-de-uso">Termos de privacidade</S.TermsLink>
  </S.Container>
);

export default Register;
